import React from "react"
import "./Testimonials.css"
import testimonials from "../../resources/data/testimonials"

export default function Testimonials() {
    return (
    <div className="testimonial-page">
        <h1>
            Testimonials
        </h1>
        <h2>
            Hear from clients themselves about what keeps them coming back! I have a wide variety of clients, some that have grown with me, and followed me from place to place, some that are brand new and just starting their skincare journey.
        </h2>
        <ul className="testimonials">
            {testimonials.map((testimonial) => (
                <li key={testimonial.id} className="testimonial">
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    {getDate(testimonial.clientSince)}
                    <p className="testimonial-content"><q>{testimonial.content}</q></p>
                </li>
            ))}
        </ul>
        <h2>
            <br/>To add your own testimonial, reach out via email, or fill out a testimonial form the next time you come in!
        </h2>
    </div>
    )
}

const currentYear = new Date().getFullYear();
function getDate(dateSince) {
    const diff = currentYear - dateSince;
    let plural = ""
    if(diff > 0 && diff < 100) {
        if (diff > 1) { plural = "s"}
        return <p className="testimonial-since">Client for over {diff} year{plural}</p>
    }
    return
}